import { IssueRecordEditable } from '@/ui/pages/issue/issueTypes';
import { AssetsPhotoStubActionable, processPhoto } from '@/services/assets-api/AssetsPhotoService';
import { photoRmFilterFn } from '@/services/assets-api/assets-helper';

export const processPhotos = async (issueRecord: IssueRecordEditable): Promise<IssueRecordEditable> => {
  if (!issueRecord.photos || issueRecord.photos.length === 0) {
    return issueRecord;
  }

  const processedPhotos = await Promise.all(
    (issueRecord.photos as Array<AssetsPhotoStubActionable>).map(processPhoto),
  );

  issueRecord.photos = processedPhotos
    .filter(photo => photo && !photoRmFilterFn(photo)) as Array<AssetsPhotoStubActionable>;

  return issueRecord;
};
